// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"761":"1b52b67f","4573":"bead3805","5422":"4e4aff88","6576":"286cec16","9363":"646ee424"}[chunkId] + ".chunk.css";
};